export const ContentType = {
  account: 'account',
  group: 'group',
  kpi: 'kpi',
  kpiGroup: 'kpiGroup',
};

export const JournalStatus = {
  posted: 'posted',
  unposted: 'unposted',
};
